<template>
  <label
    data-el="form-checkbox"
    :data-test-id="testId"
    :data-checked="modelValue || value ? '1' : '0'"
    :class="{
      'm-0 inline-flex gap-2': true,
      'relative inline-flex cursor-pointer items-center': hasSwitch,
    }"
  >
    <input
      v-bind="$attrs"
      type="checkbox"
      :required="required"
      :disabled="disabled"
      :checked="!!modelValue || !!value"
      :class="{
        peer: true,
        'sr-only': hasSwitch,
        'mt-0.5 shrink-0 rounded border-gray-300 text-sky-600 shadow-sm focus:outline-none focus:ring-4 focus:ring-sky-300':
          !hasSwitch,
        'pointer-events-none bg-gray-50 focus:ring-gray-300':
          !hasSwitch && disabled,
      }"
      :data-checkbox-checked="modelValue || value ? '1' : '0'"
      :data-value="modelValue || value"
      @input="selectChangeInput"
    />
    <span
      class="peer h-6 w-11 rounded-full border border-gray-300 bg-gray-200 after:absolute after:left-[2px] after:top-0.5 after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-sky-600 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:ring-4 peer-focus:ring-sky-300"
      v-if="hasSwitch"
    />

    <span
      class="ml-3 text-sm text-gray-600"
      v-if="labelEnabled || labelDisabled"
    >
      <span v-if="labelEnabled && (modelValue || value)">{{
        labelEnabled
      }}</span>
      <span v-if="labelDisabled && !(modelValue || value)">{{
        labelDisabled
      }}</span>
    </span>
    <slot />
  </label>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import type { FormSize } from '../../lib/services/types';
import { getLogger } from '../../lib/services/getLogger';

const log = getLogger('FormSelect');
const props = withDefaults(
  defineProps<{
    value?: boolean | null;
    modelValue?: boolean | null;
    required?: boolean;
    disabled?: boolean;
    switch?: boolean;
    labelEnabled?: string;
    labelDisabled?: string;
    testId?: string;
    size?: FormSize;
  }>(),
  {
    value: undefined,
    modelValue: undefined,
    required: false,
    disabled: false,
    switch: false,
    labelDisabled: '',
    labelEnabled: '',
    testId: undefined,
  },
);
const hasSwitch = computed(() => !!props.switch);
const emit = defineEmits<{
  (e: 'change' | 'update:modelValue', p: boolean): void;
}>();

const selectChangeInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  log('Checkbox change input: ' + target.checked);
  emit('change', target.checked);
  emit('update:modelValue', target.checked);
};
defineOptions({
  inheritAttrs: false,
});
</script>
